/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiSimpleSourceCategoryValueFromJSON, ApiSimpleSourceCategoryValueToJSON, } from './ApiSimpleSourceCategoryValue';
export function ApiSimpleSourceCategoryFromJSON(json) {
    return ApiSimpleSourceCategoryFromJSONTyped(json, false);
}
export function ApiSimpleSourceCategoryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'values': !exists(json, 'values') ? undefined : (json['values'].map(ApiSimpleSourceCategoryValueFromJSON)),
    };
}
export function ApiSimpleSourceCategoryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'values': value.values === undefined ? undefined : (value.values.map(ApiSimpleSourceCategoryValueToJSON)),
    };
}
